import { JsonObject, JsonProperty } from 'json2typescript';
import { isEmpty } from '@/common/StringUtil';
import Choice from '@/models/entry/Choice';
import Answer from './Answer';

@JsonObject('SubQuestion')
export default class SubQuestion {
  constructor() {
    this.questionCode = '';
    this.version = 0;
    this.subQuestionTitle = '';
    this.subQuestionType = '';
    this.order = 0;
    this.choices = [];
    this.answer = new Answer();
  }

  @JsonProperty('question_code')
  public questionCode: string;

  @JsonProperty('question_version')
  public version: number;

  @JsonProperty('sub_question_title')
  public subQuestionTitle: string;

  @JsonProperty('sub_question_type')
  public subQuestionType: string;

  @JsonProperty('order')
  public order: number;

  @JsonProperty('choices', [Choice], true)
  public choices: Choice[];

  public answer: Answer;

  isAnswer() {
    return this.answer.choiceCodes.length > 0 || !isEmpty(this.answer.answer);
  }
}
